import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { HomePage } from './home.page';

import { HomePageRoutingModule } from './home-routing.module';
import { SharedModule } from '../shared/shared.module';
import { VariationSelectionComponent } from '../wizard/variation-selection/variation-selection.component';
import { PaperSizeSelectionComponent } from '../wizard/paper-size-selection/paper-size-selection.component';
import { PaperTypeSelectionComponent } from '../wizard/paper-type-selection/paper-type-selection.component';
import { PaperSideSelectionComponent } from '../wizard/print-style-selection/print-style-selection.component';
import { ExtrasSelectionComponent } from '../wizard/extras-selection/extras-selection.component';
import { PrintOfficeSelectionComponent } from '../wizard/print-office-selection/print-office-selection.component';
import { FilesSelectionComponent } from '../wizard/files-selection/files-selection.component';
import { TranslateModule } from '@ngx-translate/core';
import { OfferDetailsModalComponent } from '../wizard/offer-details-modal/offer-details-modal.component';
import { PaymentSelectionComponent } from '../wizard/payment-selection/payment-selection.component';
import { GooglePayButtonModule } from '@google-pay/button-angular';
import { PaymentReceivedAuthPage } from '../payment-received-authed/payment-received-authed.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HomePageRoutingModule,
    SharedModule,
    TranslateModule,
    GooglePayButtonModule,
  ],
  declarations: [
    HomePage,
    VariationSelectionComponent,
    PaperSizeSelectionComponent,
    PaperTypeSelectionComponent,
    PaperSideSelectionComponent,
    ExtrasSelectionComponent,
    PrintOfficeSelectionComponent,
    FilesSelectionComponent,
    OfferDetailsModalComponent,
    PaymentSelectionComponent,
    PaymentReceivedAuthPage,
  ],
})
export class HomePageModule {}
